import React, {
  Component
} from 'react';
import Addmore from '../components/Addmore';
import * as Config from '../config/Config';
const jQuery=window.jQuery;
const $=window.$;

export default class Addobserver extends Component {
 constructor(props){
 	super(props);
 	this.state = {
   scrollHeight:0,
   getcountrycodes:[],
   getrelations:[]
   // optionGenderField:0
  };
 }


 getrelations(product_id){
  fetch(`${Config.domainUrl}products/${product_id}?expand=relationship`, {
   method: "GET",
   headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
   }
  }).then((response) => response.json()).then((responseJson) => {
    if(responseJson.status==1){
     if(responseJson.data.relationship.length>0){

      this.setState({getrelations:responseJson.data.relationship});
     }
    }
  });
 }

 getcountrycodes(){
  fetch(Config.domainUrl +"getcountrycodes", {
   method: "GET",
   headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
   }
  }).then((response) => response.json()).then((responseJson) => {
    if(responseJson.status==2){

     this.setState({getcountrycodes:responseJson.country_data});
    }
  });
 }

  handleChange(e){
    this.props.onClick(e);
  }

 refreshScroll(type=""){
   setTimeout(()=>{

     $(".current_index").remove();
     $('div[id^="observer"]').each(function(){
     let id=$(this).attr('id').split("_");

     $('#observer_'+id[1]).find(".genderoption").attr('name','gender_'+id[1]);

     $('#observer_'+id[1]).append('<input type="hidden" name="current_index[]" class="current_index" value="'+id[1]+'" />');

    });
   },200);

     // if(type=="add_observer"){
     //
     //   // let scrollbar1_height=jQuery('#semana-scroll-register .viewport').height();
     //
     //   this.setState({optionGenderField:this.state.optionGenderField+1});
     //   setTimeout(()=>{
     //    $('#observer_'+this.state.optionGenderField).find(".genderoption").attr('name','gender_'+this.state.optionGenderField);
     //   },200);
     //
     // }
     //
     // if(type=="remove_observer"){
     //
     //   this.setState({optionGenderField:this.state.optionGenderField-1});
     //
     // }

     let $scrollbar  =jQuery('#semana-scroll-register')
                ,   $overview   = $scrollbar.find(".overview")
                ,   loadingData = false;

       $scrollbar.tinyscrollbar({thumbSize : 20});

      let scrollbarData = $scrollbar.data("plugin_tinyscrollbar");
      $scrollbar.bind("move", function()
                {
                    // The threshold will enable us to start loading the text before we reach the end.
                    //
                    var threshold       = 0.9
                    ,   positionCurrent = scrollbarData.contentPosition + scrollbarData.viewportSize
                    ,   positionEnd     = scrollbarData.contentSize * threshold
                    ;

                    // Check if have reached the "end" and that we arent allready in the process of loading new data.
                    //
                    if(!loadingData && positionCurrent >= positionEnd)
                    {
                        //loadingData = true;
                        //
                        // $.getJSON("data.json", function(data)
                        // {
                        //     loadingData = false;
                        //
                        //     $overview.append(data.text)
                        //
                        // });
                        scrollbarData.update("relative");
                    }
                });



   }

   submit(){
      this.props.submit();
   }

   componentDidMount() {
     const {data}=this.props;
    	jQuery('#semana-scroll-register').tinyscrollbar();
     this.getcountrycodes();
     this.getrelations(data.product);
   }

  render() {

     const {data}=this.props;
     const contryCodeoptions=this.state.getcountrycodes.map((key,index)=>
     <option key={index} value={key.id}>{key.name_code}</option>
     );

     const relationoptions=this.state.getrelations.map((key,index)=>
     <option key={index} value={key.name}>{key.name}</option>
     );

    return (
     <div>
     <h1>Add Observers</h1>
    <br/>
    <p>OBSERVERS will be interacting with you right through the program. You choose your own observers, who could be your friends, family, seniors or teachers - anybody who can play a productive role in your learning and development. Many of the works you submit during the program will be reaching your observers for their feedback and rating.</p>
    <p>You need <strong>at least one observer</strong> and a maximum of any number. They will receive a mail through which they can accept your request. Please note that WITHOUT observers, you would not be able to start the program.</p>
    <p>Please fill in your details below as part of the mandatory process:</p>
    <div className="gray-box-reg">
      <section id="semana-scroll-register" className="scrollbar1">
      <section className="scrollbar">
        <section className="track">
          <section className="thumb"></section>
        </section>
      </section>
        <section className="viewport">
          <section className="overview">
            <form name="frmaddobserver" id="frmaddobserver" >
             <input type="hidden" name="learner_id" value={data.learner_id_pk}/>
             <input type="hidden" name="current_index[]" className="current_index" value="0" />
             <input type="hidden" name="gender" value="0" />
            <Addmore selector="observer" limit={3} editType="form" AddLabel="+ Add Observer" refreshScroll={e=>this.refreshScroll(e)} compType="parent" DeleteLabel="Remove">

              <div className="frm">
                <div className="frm-left">
                  <div className="frm-left-txt">Observer Name <span className="txt-red">*</span></div>
                  <div className="frm-right-txt">
                    <input name="name[]" type="text"/>

                  </div>
                </div>
                <div className="frm-right">
                  <div className="frm-left-txt">Email Id <span className="txt-red">*</span></div>
                  <div className="frm-right-txt">
                    <input name="email[]" type="text"/>

                  </div>
                </div>
                <div className="clear"></div>
                <div className="frm-left">
                  <div className="frm-left-txt">Relationship <span className="txt-red">*</span></div>
                  <div className="frm-right-txt">
                    <select name="relation[]" id="lstrelation">
                      {relationoptions}
                    </select>
                  </div>
                </div>
                <div className="frm-right">
                  <div className="frm-left-txt">Gender <span className="txt-red">*</span></div>
                  <div className="frm-right-txt">
                    <div className="radio-box">
         <input name="gender_0"  className="rdbtn genderoption" type="radio" value="1" />
                      &nbsp;Male&nbsp;
         <input name="gender_0"  className="rdbtn genderoption" type="radio" value="0" />
                      &nbsp;Female </div>
                  </div>
                </div>
                <div className="clear"></div>
                <div className="frm-left">
                  <div className="frm-left-txt">Contact Number <span className="txt-red">*</span></div>
                  <div className="frm-right-txt">
                    <select name="ISD[]" id="txtphoneISD1" >
                      <option value="">--- select ---</option>
                      {contryCodeoptions}
                    </select>

 {/* <input name="STD[]" type="text" className="textbox txtbox-mini" id="txtphoneSTD1"  maxLength="6" style={{width:"45px"}} /> */}
 <div className="frm-left-txt" style={{marginLeft: '-100px'}}>Phone <span className="txt-red">*</span></div>
         <input name="phone[]" type="text" className="textbox" id="txtphone1" maxLength="10" className="txtbox-medium" style={{width:"65%"}}/>
                    
                    {/* <span className="txt-small">  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;Phone</span> */}
                    

                  </div>
                </div>
                <div className="frm-right">&nbsp;</div>
                <div className="clear"></div>
                <div className="btm-divider"></div>
                <div className="clear"></div>
                </div>
                </Addmore>
                <center>
                  <input type="button" className="btn-green" onClick={e=>this.submit()} name="btnsubmit" value="Complete Registration" />

                </center>
            </form>
          </section>
        </section>
      </section>
    </div>
     </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/auth/Addobserver.js